import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "relative flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-faded-foreground flex items-center justify-between gap-1 text-[10px]"
}

import ThousandSeparatorInput from '@/components/ThousandSeparatorInput.vue';
    import type { CellContext, Row, Table } from '@tanstack/vue-table';
    import type { VatSubmission } from '@/types';
    import { computed, ref, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { useVatStore } from '@/stores/vat';
    import { formatCurrency } from '@/utils/helpers';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VatTableTotalInput',
  props: {
    row: {},
    table: {},
    columnId: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const vatStore = useVatStore();

    const val = (n: number | null | undefined) => n ?? 0;

    const calculatedValue = computed(
        () =>
            val(props.row.original.sales_vat) -
            val(props.row.original.purchase_vat) +
            val(props.row.original.vat_on_purchase_of_goods_abroad) +
            val(props.row.original.vat_on_purchase_of_services_abroad) -
            val(props.row.original.oil_and_bottled_gas_tax) -
            val(props.row.original.electricity_tax) -
            val(props.row.original.natural_gas_and_town_gas_tax) -
            val(props.row.original.coal_tax) -
            val(props.row.original.co2_tax) -
            val(props.row.original.water_tax),
    );

    watch(calculatedValue, (newVal) => {
        props.table.options.meta?.updateData?.(props.row, props.columnId, calculatedValue);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ThousandSeparatorInput, {
        modelValue: calculatedValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((calculatedValue).value = $event)),
        "with-decimals": "",
        placeholder: _unref(t)('vat.group_headers.vat_total'),
        class: "min-w-52 pr-8",
        disabled: true
      }, null, 8, ["modelValue", "placeholder"]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "pointer-events-none absolute right-2" }, "Kr.", -1))
    ]),
    (_unref(vatStore).showPreviousSubmission && _ctx.row.original.previous_submission)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(_ctx.row.original.previous_submission[props.columnId] as number)), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('vat.previous_submission')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})